import { Controller } from "@hotwired/stimulus"

// Manages visual state for radio-button accommodation cards.
// When a radio changes, all sibling cards are reset and the
// selected card receives highlighted styles.
export default class extends Controller {
  static targets = ["radio"]

  select() {
    // Walk every radio in this group and update its card
    this.radioTargets.forEach((radio) => {
      const label = radio.closest("label")
      const card = label.querySelector(".accommodation-card, .radio-card")
      const indicator = label.querySelector("[data-radio-cards-target='indicator']")
      const check = label.querySelector("[data-radio-cards-target='check']")
      const isDisabled = radio.disabled
      const isChecked = radio.checked

      if (!card) return

      // Reset card classes
      card.classList.remove(
        "border-blue-500", "ring-2", "ring-blue-200", "shadow-lg",
        "border-gray-200", "hover:border-blue-300", "hover:shadow-md",
        "border-blue-500", "bg-blue-50",
        "border-gray-300", "hover:border-blue-300"
      )

      if (isDisabled) {
        // Sold-out cards keep their muted styling — skip them
        return
      }

      // Is this the dashed "no accommodation" card?
      const isDashed = card.classList.contains("border-dashed")

      if (isDashed) {
        if (isChecked) {
          card.classList.add("border-blue-500", "bg-blue-50")
        } else {
          card.classList.remove("bg-blue-50")
          card.classList.add("border-gray-300", "hover:border-blue-300")
        }
        // Update icon color inside the dashed card
        const iconCircle = card.querySelector("div > div:first-child")
        const iconSvg = card.querySelector("div > div:first-child svg")
        if (iconCircle) {
          iconCircle.classList.toggle("bg-blue-100", isChecked)
          iconCircle.classList.toggle("bg-gray-100", !isChecked)
        }
        if (iconSvg) {
          iconSvg.classList.toggle("text-blue-500", isChecked)
          iconSvg.classList.toggle("text-gray-400", !isChecked)
        }
        return
      }

      // Normal card (accommodation or reservation option)
      if (isChecked) {
        card.classList.add("border-blue-500", "ring-2", "ring-blue-200", "shadow-lg")
      } else {
        card.classList.add("border-gray-200", "hover:border-blue-300", "hover:shadow-md")
      }

      // Reservation option card: update icon circle and svg
      if (card.classList.contains("reservation-option-card")) {
        const iconCircle = card.querySelector("[data-radio-cards-icon]")
        const iconSvg = card.querySelector("[data-radio-cards-icon] svg")
        if (iconCircle) {
          iconCircle.classList.toggle("bg-blue-100", isChecked)
          iconCircle.classList.toggle("bg-gray-100", !isChecked)
        }
        if (iconSvg) {
          iconSvg.classList.toggle("text-blue-500", isChecked)
          iconSvg.classList.toggle("text-gray-400", !isChecked)
        }
      }

      // Update checkmark indicator
      if (indicator) {
        indicator.classList.toggle("border-blue-500", isChecked)
        indicator.classList.toggle("bg-blue-500", isChecked)
        indicator.classList.toggle("border-white/80", !isChecked)
        indicator.classList.toggle("bg-white/30", !isChecked)
      }
      if (check) {
        check.classList.toggle("opacity-100", isChecked)
        check.classList.toggle("opacity-0", !isChecked)
      }
    })
  }
}
